import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(() =>
	createStyles({
		typography: {
			fontFamily: 'Inter-Bold, Inter, sans serif',
			fontSize: '27px',
			fontWeight: 600,
		},
	}),
);

const defaultFontColor = '#fff';
const glbColor = '#fd9644';

const FileIcon = ({ fontColor, reference, size, type }) => {
	const classes = styles();
	const fill = fontColor ? fontColor : defaultFontColor;
	return (
		<svg height={size} width={size} ref={reference} viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
			(
			<g>
				<path
					fill={glbColor}
					d="M32,10.67A10.65,10.65,0,0,0,21.39,21.33l-.06,85.34A10.65,10.65,0,0,0,32,117.33H96a10.7,10.7,0,0,0,10.67-10.66v-64l-32-32ZM69.33,48V18.67L98.67,48Z"
				/>
				<text className={classes.typography} fill={fill} transform="translate(36 104)">
					GLB
				</text>
			</g>
			)
		</svg>
	);
};

export default FileIcon;
